import { useParams } from "react-router-dom";
import metadata from "../data/site.config.json";

const useAuthorizedPages = () => {
  const params = useParams();
  const currentPageId =
    params.pageId === undefined ? metadata.defaultPage : params.pageId;
  const authorized_pages_key = `${metadata.localDB.name}_authorized_pages`;
  const authorizedPagesString = localStorage.getItem(authorized_pages_key);
  const authorizedPages = authorizedPagesString
    ? JSON.parse(authorizedPagesString)
    : [];
  const isCurrentPageAuthorized = authorizedPages.includes(currentPageId);

  return {
    authorizedPages,
    isCurrentPageAuthorized,
  };
};

export default useAuthorizedPages;
